<template>
  <div>
    <BTabs :value="value" @input="handleInput">
      <BTabItem v-for="option in rangeOptions"
                :key="option.value"
                :label="option.label"
                :value="option.value"
      />
    </BTabs>
  </div>
</template>

<script>
export default {
  name: 'RangePickerInput',
  components: {},
  computed: {
    rangeOptions() {
      return this.options.length ? this.options.length : this.defaultOptions;
    },
    prefixedStorageKey() {
      return this.storageKey ? `range-picker.${this.storageKey}` : null;
    },
  },
  data() {
    return {
      defaultOptions: [
        {
          label: '1H',
          value: '1h',
          period: {
            amount: 1,
            unit: 'hours'
          }
        },
        {
          label: '1D',
          value: '1d',
          period: {
            amount: 1,
            unit: 'days'
          }
        },
        {
          label: '1W',
          value: '1w',
          period: {
            amount: 1,
            unit: 'weeks'
          }
        },
        {
          label: '1M',
          value: '1m',
          period: {
            amount: 1,
            unit: 'months'
          }
        },
        {
          label: '3M',
          value: '3m',
          period: {
            amount: 3,
            unit: 'months'
          }
        },
        {
          label: '1Y',
          value: '1y',
          period: {
            amount: 1,
            unit: 'years'
          }
        },
        {
          label: 'ALL',
          value: 'all',
          period: {
            amount: 10,
            unit: 'years'
          }
        },

      ]
    };
  },
  methods: {
    handleInput(value) {

      if (this.prefixedStorageKey) {
        window.app.storage.setItem(this.prefixedStorageKey, value);
      }

      this.$emit('input', value);
    },
  },
  props: {
    options: {
      default: () => [],
      required: false,
      type: Array,
    },
    storageKey: {
      required: false,
      type: String,
    },
    value: {
      default: () => {
        return window.app.storage.getItem(this.prefixedStorageKey) ? window.app.storage.getItem(this.prefixedStorageKey) : '1w';
      },
      required: false,
    },
  },
};
</script>

<style lang="scss">

</style>
